// global variables - user answers
var selectedAnswers = new Array();

// resume of user answers
const resumeSelectedAnswers = [];

// Temporal: Skin Type Answer
var skin_type = "";

$(document).ready(function () {
  // answers string to alphacharacter ID
  function stringToID(string) {
    string = string.replace(/[^a-z0-9+]+/gi, "");
    string = string.toLowerCase().replace(/\s+/g, "");
    return string;
  }

  // navigation
  $("[data-next-step]").on("click", function () {
    let next_step = parseInt($(this).attr("data-next-step"));
    $(this).parents("section").removeClass("active");

    //validating steps - navigation questions
    switch (next_step) {
      case 3:
        //question 2
        if ($(this).attr("data-type-skin") != "combination") {
          $("[data-section-step='3']").removeClass("active");
          $("[data-section-step='4']").addClass("active");
        } else {
          $("[data-section-step='" + next_step + "']").addClass("active");
        }
        break;

      case 5:
        //question 4
        if ($(this).attr("data-sensitive-skin") == "not-at-all") {
          $("[data-section-step='5']").removeClass("active");
          $("[data-section-step='6']").addClass("active");
        } else {
          $("[data-section-step='" + next_step + "']").addClass("active");
        }
        break;

      case 8:
        //question 7
        let answer_step7 = $(this).attr("data-skin-concern");
        let answer_step6 = selectedAnswers.step6;
        let skin_combinations = answer_step6 + "_" + answer_step7;

        if (
          !skin_combinations.includes("acne") &&
          skin_combinations.includes("redness")
        ) {
          $("[data-section-step='8']").removeClass("active");
          $("[data-section-step='11']").addClass("active");
          $("[data-section-step='9'],[data-section-step='10']").remove();
        } else if (
          skin_combinations.includes("acne") &&
          !skin_combinations.includes("redness")
        ) {
          $("[data-section-step='10']")
            .find("[data-next-step]")
            .attr("data-next-step", "12");
          $("[data-section-step='11']").remove();
          $("[data-section-step='" + next_step + "']").addClass("active");
        } else if (
          !skin_combinations.includes("acne") &&
          !skin_combinations.includes("redness")
        ) {
          $("[data-section-step='8']").removeClass("active");
          $("[data-section-step='12']").addClass("active");
          $(
            "[data-section-step='9'],[data-section-step='10'],[data-section-step='11']"
          ).remove();
        } else {
          $("[data-section-step='" + next_step + "']").addClass("active");
        }
        break;

      case 14:
        // concatanate answers and add klaviyo results products handle
        var finalAnswers = "";
        for (var key in selectedAnswers) {
          if (selectedAnswers.hasOwnProperty(key))
            finalAnswers += selectedAnswers[key];
        }
        var answer = quizAnswers[finalAnswers];
        var productHandles =
          answer.hero_products_handles[0] +
          ", " +
          answer.hero_products_handles[1];
        $("#q_results_products").val(productHandles);
      default:
        $("[data-section-step='" + next_step + "']").addClass("active");
    }

    // Google Analytics
    let ga_question = $(this).attr("data-ga-question");
    let ga_answer = $(this).attr("data-ga-answer");
    let ga_type = $(this).attr("data-ga-type");

    // if(ga_type == 'result'){
    //   ga('send', 'event', 'Skin Quiz', ga_type, ga_answer);
    // }else if(ga_type == 'question' ){
    //   ga('send', 'event', 'Skin Quiz', ga_type, ga_question);
    // }else if(ga_type == "header"){
    //   ga('send', 'event', 'Skin Quiz', 'viewed intro page', 'intro page');
    // }else if(ga_type == "klaviyo-form"){
    //   ga('send', 'event', 'Skin Quiz', 'viewed email capture', 'email capture');
    // }

    $("html, body").animate({ scrollTop: 0 }, 700);
  });

  //Event for send  answer  to Google Analitics
  // $(".button_answer").on("click", function () {
  //   // Google Analytics
  //   if ($(this).attr("data-ga-type") == "header") {
  //     ga("send", "event", "Skin Quiz", "started quiz", "get started");
  //   } else if ($(this).attr("data-ga-type") == "klaviyo-form") {
  //     ga("send", "event", "Skin Quiz", "captured email", "sign up");
  //   } else {
  //     let ga_question = $(this).attr("data-ga-question");
  //     let ga_answer = $(this).attr("data-ga-answer");
  //     ga("send", "event", "Skin Quiz", ga_question, ga_answer);
  //     //klaviyo custom properties
  //     if ($(this).attr("data-klaviyo-field") != undefined) {
  //       let klaviyo_field_id = $(this).attr("data-klaviyo-field");
  //       $("#" + klaviyo_field_id).val(ga_answer);
  //     }
  //   }
  // });

  // find an answer that matches our data object
  $("[data-key-answer]").on("click", function () {
    let step =
      "step" + $(this).parents("[data-section-step]").attr("data-section-step");
    let value = $(this).attr("data-key-answer");

    //answer for type of skin
    if ($(this).attr("data-type-skin")) {
      skin_type = $(this).attr("data-type-skin");
    }

    //answers for resume
    resumeSelectedAnswers.push(value);

    value = stringToID(value);
    selectedAnswers[step] = value;

    //validating - no repeat answer on step 7
    let data_step = $(this)
      .parents("[data-section-step]")
      .attr("data-section-step");
    if (data_step == "6") {
      let value_for_validation = $(this).attr("data-key-answer");
      $("[data-section-step='7']")
        .find("[data-key-answer='" + value_for_validation + "']")
        .parent(".cardGrid__card")
        .hide();
    }
  });

  $("[data-submit]").on("click", function () {
    productsRecomendationTemplate();
  });

  //method for products 'recomendations' and 'you may also like'
  function productsRecomendationTemplate() {
    //concatenate user results
    var finalAnswers = "";
    for (var key in selectedAnswers) {
      if (selectedAnswers.hasOwnProperty(key))
        finalAnswers += selectedAnswers[key];
    }

    //concatenate user answers for resume text
    let string_selected_answers = "";
    for (var k = 0; k < resumeSelectedAnswers.length; k++) {
      if (k != 0) {
        if (k == 1) {
          if (skin_type != "") {
            string_selected_answers += skin_type + " skin, ";
          } else {
            string_selected_answers += resumeSelectedAnswers[k] + " skin, ";
          }
        } else if (k == 2) {
          string_selected_answers += resumeSelectedAnswers[k] + ", and ";
        } else {
          string_selected_answers += resumeSelectedAnswers[k] + ", ";
        }
      }
    }
    $(".resumeConcern__text").prepend(string_selected_answers.toLowerCase());

    //concatenate hero products for data-ga-answer
    var concat_ga_answers = "";

    // find an answer that matches our data object
    var answer = quizAnswers[finalAnswers];
    console.log("Answer ID: " + finalAnswers);
    // create template for hero products
    for (var i in answer.hero_products_handles) {
      var productObject = quizProducts[answer.hero_products_handles[i]];
      console.log(productObject);
      //create template for hero products
      var template_heroProducts = `
        <div class='heroProducts__card'>
        <img src='${productObject.featured_image}'>
        <p class="heroProducts__title">${productObject.title}</p>
        ${productObject.reviews}
        <p class="heroProducts__prices">${productObject.price}  <span>${
        productObject.comparePrice.length > 0 ? "| Value" : ""
      }  ${productObject.comparePrice}</span></p>
        <a class="heroProducts__addCart" href='/cart' data-variant-id="${
          productObject.variant_id
        }"  add-to-cart>ADD TO CART</a>
        <p class="heroProducts__excerpt">${productObject.excerpt}</p>
        </div>
        ${i == 0 ? '<span class="heroProducts__plusIcon">+</span>' : ""}
        `;
      $(".skinCareQuiz__heroProducts").append(template_heroProducts);
      concat_ga_answers += productObject.product_handle + " ";
    }

    // Make title elements the same height as the tallest title
    var max_title_height = 0;
    var $titles = $(".heroProducts__title");
    $titles.each(function () {
      var current_height = $(this).height();
      if (current_height > max_title_height) {
        max_title_height = current_height;
      }
    });
    $titles.height(max_title_height);

    $(".finalStep").attr("data-ga-answer", concat_ga_answers);

    // create template for you may also like products
    for (var j in answer.you_may_also_like_handles) {
      let product = quizProducts[answer.you_may_also_like_handles[j]];
      //create template for hero products
      var template_youMayLikeProducts = `
        <div class='youMayLikeProducts__card'>
        <img src='${product.featured_image}'> 
        <p class="youMayLikeProducts__title">${product.title}</p>
        ${product.reviews}
        <p class="youMayLikeProducts__prices">${product.price}  <span>${
        productObject.comparePrice.length > 0 ? "| Value" : ""
      } ${product.comparePrice}</span></p>
        <a class="youMayLikeProducts__addCart" href='/cart' data-variant-id="${
          product.variant_id
        }" add-to-cart>ADD TO CART</a>
        <p class="youMayLikeProducts__excerpt">${product.excerpt}</p>
        </div>
        `;

      $(".skinCareQuiz__youMayLikeProducts").append(
        template_youMayLikeProducts
      );
    }

    // Google Analytics
    let ga_question = $(".finalStep").attr("data-ga-question");
    let ga_answer = $(".finalStep").attr("data-ga-answer");
    //ga("send", "event", "Skin Quiz", ga_question, ga_answer);

    //slider for you may also like - mobile
    if ($(window).width() < 1025) {
      $(".skinCareQuiz__youMayLikeProducts").slick({
        dots: false,
        arrows: true,
        speed: 300,
        touchThreshold: 15,
        nextArrow:
          '<button class="slider-arrow arrow-next slick-arrow" style="display: block;"><i class="fa fa-angle-right"></i></button>',
        prevArrow:
          '<button class="slider-arrow arrow-prev slick-arrow" style="display: block;"><i class="fa fa-angle-left"></i></button>',
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  }

  $(".skinCareQuiz__lastStep .button_answer").on("click", function () {
    var answers = $("#quiz_form input").filter(function () {
      return this.value != "" && this.id.indexOf("q_") > -1;
    });
    answers.each(function () {
      var html = "";
      var row =
        '<div><span class="question">' +
        $(this).attr("name") +
        '</span> <span class="answer">' +
        $(this).val() +
        "</span></div>";

      $(".skinCareQuiz__answersList").append(row);
    });
  });
});
